<template>
  <div>
    <slot-new-dialog :state="slotNewDialog" :classData="classData" />
    <slot-drawer
      v-if="slotInfoDialog"
      :state="slotInfoDialog"
      :slotData="selectedSlot"
      @onDrawerStateChange="updateInfoDialog"
    ></slot-drawer>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          v-if="classData"
          :data="classData.title"
          headline="Lịch học"
          :link="[
            { text: 'Lớp học', href: '../../../classes' },
            {
              text: classData.title,
              id: classData.id,
              href: `../../class/${classData.id}`
            },
            { text: 'Lịch học' }
          ]"
        />
      </div>
      <div class="d-flex justify-end">
        <v-btn
          v-if="['education_manager', 'super_admin'].includes(role.type)"
          v-show="selectedSlots.length > 0"
          class="mr-2"
          :class="{ 'mt-2': $vuetify.breakpoint.mdAndUp }"
          color="error"
          @click="onDelete"
          ><v-icon left>mdi-delete</v-icon>{{ deleteButtonText }}</v-btn
        >
        <v-btn
          v-if="['education_manager', 'super_admin'].includes(role.type)"
          :class="{ 'mt-2': $vuetify.breakpoint.mdAndUp }"
          color="success"
          @click="onAdd"
          ><v-icon left>add</v-icon>{{ addButtonText }}</v-btn
        >
      </div>
    </div>

    <v-card elevation="1" class="mx-md-2 mt-2">
      <slots-table
        v-model="selectedSlots"
        class="px-6 mt-n2"
        item-key="id"
        :headers="getHeaders"
        :slots="slotData"
        :loading="loading"
        loading-text="Đang Tải"
        @onSelectionChanged="onSelectionChanged"
        @edit="onEdit"
        @add="onAdd"
        show-select
        add
      ></slots-table>
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import SlotDrawer from '@/modules/class/slot/SlotDrawer'
import SlotsTable from '@/modules/slot/SlotsTable'
import SlotNewDialog from '@/modules/class/slot/SlotNewDialog'
import moment from 'moment'
export default {
  components: {
    SlotDrawer,
    SlotNewDialog,
    SlotsTable,
    Breadcrumbs
  },

  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'STT',
          align: 'left',
          sortable: false,
          value: 'index'
        },
        {
          text: 'Thời gian',
          value: 'startTime',
          align: 'left',
          sortable: false
        },
        {
          text: 'Phân loại',
          value: 'category',
          align: 'left',
          sortable: false
        },
        {
          text: 'Ngày',
          value: 'startTimeDate',
          align: 'left',
          sortable: false
        },
        { text: 'Phòng học', value: 'room', align: 'left', sortable: true },
        { text: 'Giáo viên', value: 'teachers', align: 'left', sortable: true },
        { text: 'Trợ giảng', value: 'mentors', align: 'left', sortable: true },
        { text: 'Hành động', value: 'actions', align: 'left', sortable: true }
      ],
      selectedSlot: {},
      selectedSlots: [],
      search: '',
      slotNewDialog: false,
      slotInfoDialog: false,
      status: null,
      defaultFilters: {
        class: this.classData
      },
      filters: {},
      count: 0
    }
  },
  async created() {
    const classId = this.$route.params.id
    await this.refresh()
    await this.initClass({ id: classId })
    await this.fetchSlots({ class: classId })
  },
  computed: {
    ...mapGetters('classDetail', ['classData', 'slots', 'classList', 'attendances']),
    ...mapState('auth', ['user', 'role']),
    ...mapState('constant', ['slotStatus']),
    ...mapState('app', ['department']),
    slotData() {
      return this.slots.map((s, index) => {
        let startTimeDate = moment(s.startTime).format('dddd, DD/MM')
        return {
          ...s,
          startTimeDate: this.replaceDatetime(startTimeDate),
          index: index + 1,
        }
      })
    },
    deleteButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Xóa'
        default:
          return 'Xóa buổi học'
      }
    },
    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm buổi học'
      }
    },
    getHeaders() {
      if (!['education_manager', 'super_admin'].includes(this.role.type)) {
        return this.headers.filter(header => header.value !== 'actions')
      }
      return this.headers
    }
  },

  methods: {
    ...mapActions('classDetail', ['fetchSlots', 'setSlots', 'initClass', 'removeSlots']),
    updateInfoDialog(slotInfoDialog) {
      this.slotInfoDialog = slotInfoDialog
    },
    refresh(query) {
      this.filters = query || {}
    },
    onAdd() {
      this.slotNewDialog = !this.slotNewDialog
    },
    onEdit(selected) {
      this.selectedSlot = selected
      this.slotInfoDialog = !this.slotInfoDialog
    },
    onDelete() {
      if (this.selectedSlots.length > 0) {
        this.$dialog.confirm({
          title: 'Thông báo xác nhân',
          text: `Xóa các buổi học sẽ xóa toàn bộ thông tin điểm danh, chấm công và tính lương của giáo viên. Bạn có Chắc Chắn ?`,
          okText: 'OK',
          cancelText: 'Hủy',
          done: async () => {
            this.removeSlots(this.selectedSlots)
            this.selectedSlots = []
          }
        })
      }
    },
    onSelectionChanged(selection) {
      this.selectedSlots = selection
    },
    replaceDatetime(startTimeDate) {
      return startTimeDate
        .replace('thứ hai', 'Thứ 2')
        .replace('thứ ba', 'Thứ 3')
        .replace('thứ tư', 'Thứ 4')
        .replace('thứ năm', 'Thứ 5')
        .replace('thứ sáu', 'Thứ 6')
        .replace('thứ bảy', 'Thứ 7')
        .replace('chủ nhật', 'CN')
    }
  }
}
</script>
